import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {CreateProjectRequest, Project} from '../../../../core/models';
import {EventService, FileHelperService} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';
import {ProjectService, ReleaseBundleService} from '../../../../core/services';


@Component({
  selector: 'app-project-creation',
  templateUrl: './project-creation.page.html'
})
export class ProjectCreationPage implements OnInit {
  @Input() project: Project = {};


  saving = false;
  authUser: AuthUser = this.token.whoAmI();

  constructor(
    private router: Router,
    private token: TokenService,
    private projectService: ProjectService,
    private fileHelperService: FileHelperService,
    private eventService: EventService,
    private releaseBundleService: ReleaseBundleService
  ) {
  }

  ngOnInit() {
    this.project.platform = {};
  }

  backToList() {
    this.router.navigate(['/project', 'list']);
  }

  saveProject() {
    if (this.validate(this.project)) {
      this.createProject(this.project);
    }

  }

  validate(project: Project) {
    if (this.project.name == null) {
      this.eventService.error('Name is required');
      return false;
    }
    return true;
  }


  removeImage() {
    delete (this.project.image);
  }

  storeFile(event) {
    const file = event.files[0];
    if (!file.type.startsWith('image/')) {
      this.eventService.warn('invalid content, please uplaod an image');
      return;
    }
    this.fileHelperService.fileToDataUrl(file, (data) => {
      this.project.image = data;
    });
  }

  createProject(project: Project) {

    const customerName = this.authUser.currentCustomer.name !== this.authUser.loginCustomer.name
      ? this.authUser.currentCustomer.name : null;
    const adminGroupAccess = customerName == null ? false : true;


    const req = new CreateProjectRequest(project.name, project.externalId, project.image,
         customerName, adminGroupAccess, project.platform.name);

    this.projectService.create(req).subscribe(
      (data) => {
        this.router.navigate(['/project', data.id]);
      }
    );
  }

  getVersion(clientFile) {
    return (
      clientFile.majorVersion +
      '.' +
      clientFile.minorVersion +
      '.' +
      clientFile.patchVersion +
      '.' +
      clientFile.buildNumber
    );
  }
}
